// import React, { useState, useEffect } from "react";
// import "./css/navbar.css"; // External CSS file

// const Navbar = () => {
//   const [isLowerNavVisible, setIsLowerNavVisible] = useState(true);
//   const [prevScrollPos, setPrevScrollPos] = useState(0);

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollPos = window.scrollY;

//       if (currentScrollPos < 10 || prevScrollPos > currentScrollPos) {
//         setIsLowerNavVisible(true);
//       } else {
//         setIsLowerNavVisible(false);
//       }

//       setPrevScrollPos(currentScrollPos);
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, [prevScrollPos]);

//   return (
//     <nav className="navbar">
//       {/* Upper Navigation */}
//       <div className="upper-nav">
//         <div className="container">
//           <div className="menu-icon">&#9776;</div>
//           <div className="logo">
//             <h1>THE SUCESS</h1>
//             <p>DIGEST</p>
//           </div>
//           <div className="search-icon">&#128269;</div>
//         </div>
//       </div>

//       {/* Lower Navigation */}
//       <div
//         className="lower-nav"
//         style={{
//           transform: isLowerNavVisible ? "translateY(80px)" : "translateY(0px)",
//           opacity: isLowerNavVisible ? "1" : "0",
//         }}
//       >
//         <div className="container" id="nav-container">
//           <ul>
//             <li>
//               <a href="#">home</a>
//             </li>
//             <li>
//               <a href="#">MAGAZINE</a>
//             </li>
//             <li>
//               <a href="#">NEWS</a>
//             </li>
//             <li>
//               <a href="#">FEATURED ARTICLE</a>
//             </li>
//             <li>
//               <a href="#">BLOGS</a>
//             </li>
//             <li>
//               <a href="#">ABOUT US</a>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;




import React, { useState, useEffect } from "react";
import "./css/navnew.css";
import { AlignJustify, AlignJustifyIcon, Search } from "lucide-react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [lastScrollPosition, setLastScrollPosition] = useState(0);
  const [headerHidden, setHeaderHidden] = useState(false);
  const [searchActive, setSearchActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPosition = window.scrollY;

      if (currentScrollPosition > lastScrollPosition && currentScrollPosition > 100) {
        setHeaderHidden(true);
      } else {
        setHeaderHidden(false);
      }

      setLastScrollPosition(currentScrollPosition);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollPosition]);

  return (
    <>
      <div className="top-bar">
      <div className="upper-nav">
        <div className="container">
          <div className="menu-icon">
          <AlignJustify />
          </div>
          <div className="logo">
            <h1>ENTREPRENEUR</h1>
            <p>INSIGHTS</p>
          </div>
          <div >
          <div className="search-container">
          <div
            id="search-toggle"
            onClick={() => setSearchActive(!searchActive)}
            
          ><Search /></div>
        </div>
        <form className={`search-box ${searchActive ? "active" : ""}`}>
          <input type="search" id="search-input" placeholder="search here..." />
          <label htmlFor="search-input" className="fa fa-search"></label>
        </form>
          </div>
        </div>
      </div>
      </div>
      <header
        className={`main-header ${headerHidden ? "hidden" : ""}`}
        id="main-header"
        style={{
          transform: headerHidden ? "translateY(-100%)" : "translateY(0)",
          transition: "transform 0.3s ease-out",
        }}
      >
       
        {/* <div className="site-logo">
          <h1>Global Leaders</h1>
        </div> */}
        <ul className="nav-list">
          {/* <li><Link to="/home">Home</Link></li> */}
          <li><Link to="/magazines">magazines</Link></li>
          <li><Link to="/leaders-insights">entrepreneur insights</Link></li>
          <li><Link to="/cover-stories">cover story</Link></li>
          <li><Link to="/latest-news">news</Link></li>
          <li><Link to="/articles">articles</Link></li>
          <li><Link to="/about-us">about us</Link></li>
          
        </ul>
        
      </header>
      
    </>
  );
};

export default Navbar;
    